import { render, staticRenderFns } from "./DefaultLayoutNoStatus.vue?vue&type=template&id=8d8908a4&"
import script from "./DefaultLayoutNoStatus.vue?vue&type=script&lang=js&"
export * from "./DefaultLayoutNoStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports